import React from 'react';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/trains';

const ListRaces = () => {
  const filter = {};

  return (
    <ListResource
    {...{
      searchable: true,
      api,
      sort: { createdAt: -1 },
      filter,
      actions: {
        create: false,
        remove: false,
        fileExport: true,
      },
      cols: [
        { key: 'owner', sortable: true },
        { key: 'horse.mint', sortable: true },
        { key: 'status', sortable: true },
        {
          key: 'createdAt',
          sortable: true,
          getter(v) {
            return v ? v.toLocaleString() : '';
          },
        },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListRaces;
